/**
 * @copyright 2019 @ DigiNet
 * @author kimlong
 * @create 2019/01/11 10:37
 * @update 2019/01/11 10:37
 * @file src/components/common/print/print.js
 */

import React from 'react';
import DropDownReportTemplate from "../../common/dropdown/template/dropdown-report-template";
import FileViewer from "../../common/fileviewer/fileviewer";
import Config from "../../../config";
import PropTypes from 'prop-types';
import {TextBox} from "devextreme-react";
import Button from "../../common/button/button";
import { Row, Col, Modal, ModalHeader, ModalBody, Button as ButtonCore, Label } from 'diginet-core-ui/components';

class Print extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            reportID: '',
            reportName: '',
            url: '',
            urlPreview: '',
            fileExt: '',
            report: null,
            openFileView: false
        };
        this.passParam = false;
    }

    onHide() {
        const {onHide} = this.props;
        if (onHide) {
            onHide(this.isSaved && this.state);
        }
    }

    printReport(mode, isPreview = false) {
        const param = [...this.props.param];
        const { beforePreviewTemplate, onExportExcel } = this.props; 
        const {report, url, reportID, reportName, reportTypeID, fileExt} = this.state;
        param.push({type: "Varchar", id: "ReportID", value: reportID});
        if (Config.isEmpty(mode) && fileExt === 'pdf') mode = 1;
        const options = {
            reportURL: url,
            reportID: reportID,
            reportName: reportName,
            reportTypeID: reportTypeID,
            isPDF: mode === 1 ? 1 : 0,
            exportType: mode === 1 ? "pdf" : (report?.FileExt ? report?.FileExt.replace('.', '') : ""),
            strSQL: report?.StrSQL ? report?.StrSQL : "",
            fileExt
        };
        if (isPreview) {
            if (!this.passParam) beforePreviewTemplate && beforePreviewTemplate(param, options, (ID) => this.onPreview(true, ID));
            this.onPreview(true)
        }
        else onExportExcel && onExportExcel(param, options);
    }

    onChangeReportTemplate(data) {
        this.passParam = false;
        this.setState({
            reportID: data.ReportID,
            reportName: data.Title,
            url: data.URL,
            report: data,
            fileExt: data.FileExt ? data.FileExt.replace(".", "") : ""
        });
    };

    onPreview = (status = false, ID = '') => {
        const objState = { openFileView: status };
        if (ID) objState.urlPreview = ID;
        this.passParam = true;
        this.setState(objState);
    };

    render() {
        const { reportTypeID, hideBtnExcel, hideBtnPdf, btnLoading, isPreview } = this.props;
        const { report, reportName, fileExt, openFileView, urlPreview } = this.state;
        const disabled = !!Object.keys(btnLoading).find(l => btnLoading[l]);
    
        return (
            <Modal
                open
                size={'md'}
                onClose={() => this.onHide()} >
                <ModalHeader>{Config.lang("Chon_mau_bao_cao")}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Modal
                            open={openFileView}
                            size={'lg'}
                            onClose={() => this.onPreview(false)} >
                            <ModalHeader>{reportName}</ModalHeader>
                            <ModalBody>
                                <FileViewer
                                    fileName={reportName}
                                    filePath={urlPreview}
                                    fileType={fileExt}
                                />
                            </ModalBody>
                        </Modal>
                        <Col xs={12} sm={4}>
                            <Label className={'mgb1x'} required>{Config.lang("Mau_bao_cao")}</Label>
                            <DropDownReportTemplate
                                required={true}
                                modePopUp={true}
                                reportTypeID={reportTypeID}
                                displayExpr={"ReportID"}
                                placeholder={""}
                                onChange={(data) => this.onChangeReportTemplate(data)}>
                            </DropDownReportTemplate>
                        </Col>
                        <Col xs={12} sm={8} verticalAlign={'end'}>
                            <TextBox name={"ReportName"}
                                value={this.state.reportName}
                                disabled={true}
                                className="input-devextreme"
                            >
                            </TextBox>
                        </Col>
                        <Col xs={12}>
                            <div className={'jus-end'}>
                                {isPreview ? (
                                    <>
                                        <ButtonCore
                                            color={'primary'}
                                            viewType={'outlined'}
                                            startIcon={"PaperView"}
                                            label={Config.lang('Preview')}
                                            disabled={disabled || !report}
                                            onClick={() => this.printReport(null, true)}
                                        />
                                        <ButtonCore
                                            color={'primary'}
                                            viewType={'filled'}
                                            startIcon={"Printer"}
                                            className={'mgl2x'}
                                            label={Config.lang('In1')}
                                            disabled={disabled || !report}
                                            onClick={() => this.printReport()}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {(report?.ReportType === "Word" || !report) &&
                                            <Button isLoading={btnLoading?.word || false}
                                                onClick={() => {
                                                    if (!btnLoading?.word) this.printReport(2)
                                                }}
                                                type={"word"}
                                                disabled={disabled || !report}
                                                className={`${!disabled ? '' : 'isDisabled'} mgr5 pull-right`}
                                                name={Config.lang("CRM_Xuat_word")}
                                            />}
                                        {((hideBtnExcel && report?.ReportType === "Excel") || !report) &&
                                            <Button isLoading={btnLoading?.excel || false}
                                                onClick={() => {
                                                    if (!btnLoading?.excel) this.printReport(0)
                                                }}
                                                type={"excel"}
                                                disabled={disabled || !report}
                                                className={`${!disabled ? '' : 'isDisabled'} mgr5 pull-right`}
                                                name={Config.lang("CRM_Xuat_Excel")}
                                            />}
                                        {((hideBtnPdf && report?.IsConvertPDF === 1) || !report) &&
                                            <Button className={`${!disabled ? '' : 'isDisabled'} mgr5 pull-right`}
                                                onClick={() => {
                                                    if (!btnLoading?.pdf) this.printReport(1)
                                                }}
                                                type={"pdf"}
                                                disabled={disabled || !report}
                                                isLoading={btnLoading?.pdf || false}
                                                name={Config.lang("CRM_Xuat_PDF")}
                                            />}
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        )
    }
}

Print.defaultProps = {
    isPreview: false
};

Print.propTypes = {
    reportTypeID: PropTypes.string,
    param: PropTypes.array,
    hideBtnExcel: PropTypes.bool,
    hideBtnPdf: PropTypes.bool,
    isLoading: PropTypes.bool,
    isDisabledEXCEL: PropTypes.bool,
    isDisabledPDF: PropTypes.bool,
    onExportExcel: PropTypes.func,
    isPreview: PropTypes.bool,
    beforePreviewTemplate: PropTypes.func,
};
export default (Print);
